module.exports = __webpack_public_path__ + "static/android-ios-eb474e3a16c57a47ad992e4b37d44247.jpeg";